"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represents a course enrollment
 * @param {Object} enrollment object
 * @param {string} enrollment.userId
 * @param {string} enrollment.courseId id of the course the user is enrolled in
 * @param {timestamp} enrollment.timeEnrolled
 * @param {string} enrollment.subscriptionTier course subscription tier
 */
class CourseEnrollment {
    constructor(fields) {
        if (!fields) {
            return;
        }
        Object.assign(this, fields);
    }
}
exports.default = CourseEnrollment;
//# sourceMappingURL=CourseEnrollment.js.map